import { Card } from '@/shared/ui/card';
import cn from 'classnames';
import styles from './index.module.sass';
import { StatsItem } from './components';
import { WarehouseItem } from '@/modules/mixing/ts/index';

export const ProgressWidget = ({ className, data }: IProgressWidget) => {
  // ]console.log(data)
  return (
    <Card className={cn(className, styles.progressWidget)}>
      <h3 className={styles.widgetTitle}>Статистика складов</h3>
      <div className={styles.statsWrap}>
        { data && <ul className={styles.itemsList}>
          {data.map((item, i) => (
            <StatsItem key={i} item={item} />
          ))}
        </ul>}
      </div>
    </Card>
  );
};

interface IProgressWidget {
  className?: string;
  data: WarehouseItem[];
}
